<template>
  <div
    style="display: inline-block; display: inline-flex; vertical-align: middle"
  >
    <PopoverBox ref="popOverRef" :width="'300'" @show="showFn">
      <template #conent>
        <span class="el-dropdown-link">
          <el-avatar :src="userPhoto" :size="32" fit="contain">
            <el-avatar :size="32" :src="circleUrl" />
          </el-avatar>
          <div class="user_name"
            >{{ userStore.getUserInfo?.nickname || 'admin'
            }}<i class="font_family right_icon">&#xe622;</i></div
          >
        </span>
      </template>
      <template #popConent>
        <div class="pop_box">
          <div class="header">
            <el-avatar
              :src="userPhoto"
              :size="42"
              style="min-width: 42px"
              fit="contain"
            >
              <el-avatar :size="42" style="min-width: 42px" :src="circleUrl" />
            </el-avatar>
            <div class="header_right">
              <p>{{ userStore.getUserInfo?.nickname || 'admin' }}</p>
              <div style="display: flex; flex-wrap: wrap; gap: 5px">
                <el-tag
                  v-for="name in userStore.getUserInfo?.roleNames ?? []"
                  type="info"
                  size="small"
                  >{{ name }}</el-tag
                >
              </div>
            </div>
          </div>
          <div class="pop_item" @click="updatePhoneDialogVisible = true">
            <div>手机号</div>
            <div style="display: flex; align-items: center"
              >{{ userStore.getUserInfo?.username || '' }}
              <SvgIcon svgId="#icon-line32" class="icon-play"></SvgIcon>
            </div>
          </div>
          <div class="pop_item" @click="userBindOpenIdFn">
            <div>微信绑定</div>
            <div style="display: flex; align-items: center">
              <span v-if="isEmpty(openId)">未绑定</span>
              <span v-else>已绑定</span>

              <SvgIcon svgId="#icon-line32" class="icon-play"></SvgIcon>
            </div>
          </div>
          <div class="pop_item" @click="userBindYishitongFn">
            <div>医事通绑定</div>
            <div style="display: flex; align-items: center">
              <span v-if="isEmpty(userStore.getBindYishitongInfo)">未绑定</span>
              <span v-else>已绑定</span>

              <SvgIcon svgId="#icon-line32" class="icon-play"></SvgIcon>
            </div>
          </div>

          <div class="pop_item" @click="updatePwdDialogVisible = true">
            <div>密码</div>
            <div style="display: flex; align-items: center"
              >更改密码<SvgIcon svgId="#icon-line32" class="icon-play"></SvgIcon
            ></div>
          </div>
          <div class="pop_item" @click="jumpProductCenterFn">
            <div>产品中心</div>
            <div style="display: flex; align-items: center"
              ><SvgIcon svgId="#icon-line32" class="icon-play"></SvgIcon
            ></div>
          </div>
          <div class="pop_item" @click="logout">
            <div>退出登录</div>
            <div
              ><SvgIcon svgId="#icon-line32" class="icon-play"></SvgIcon
            ></div>
          </div>
        </div>
      </template>
    </PopoverBox>
    <UpdatePwdDialog v-model:isShow="updatePwdDialogVisible" />
    <UpdatePhoneDialog v-model:isShow="updatePhoneDialogVisible" />
    <BindWeixin v-model:isShow="bindWeixinVisible" />
    <BindYishitong v-model:isShow="bindYishitongVisible" />
  </div>
</template>

<script lang="ts" setup>
import { ArrowDown } from '@element-plus/icons-vue'
import { useUserStore } from '@/store/modules/user'
import UpdatePwdDialog from './UpdatePwdDialog.vue'
import UpdatePhoneDialog from './UpdatePhoneDialog.vue'
import BindWeixin from './bindWeixin.vue'
import BindYishitong from './bindYishitong.vue'
import {
  userUnBindOpenId,
  userBindDetail,
  userBindDelete,
} from '@/api/manage/clinicSetting'
import { isEmpty } from '@/libs/utils/data-checker'
import { getQrcode } from '@/api/login'
const router = useRouter()
const userStore = useUserStore()
const circleUrl =
  'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
const userPhoto = computed(() => userStore.getUserInfo?.avatar)
const openId = computed(() => userStore.getUserInfo?.openId)
const updatePwdDialogVisible = ref(false)
const updatePhoneDialogVisible = ref(false)
const bindWeixinVisible = ref(false)
const bindYishitongVisible = ref(false)
const menuList = reactive([
  { title: '首页', link: '/', divided: false },
  { title: '个人信息', link: '/personal/info', divided: false },
  { title: '修改密码', name: 'updatePwd', divided: false },
  { title: '退出', name: 'exit', link: '/login', divided: true },
])
const userBindOpenIdFn = async row => {
  if (isEmpty(openId.value)) {
    bindWeixinVisible.value = true
  } else {
    ElMessageBox.confirm('确定要解除微信绑定吗？', '提示', {
      confirmButtonText: '确定',
      type: 'warning',
    }).then(async () => {
      const res = await userUnBindOpenId({ openid: openId.value, type: 31 })
      if (res.code == 0) {
        userStore.setOpenId(null)
        ElMessage.success('解除成功')
      }
    })
  }
}
const userBindYishitongFn = async row => {
  if (isEmpty(userStore.getBindYishitongInfo)) {
    bindYishitongVisible.value = true
  } else {
    ElMessageBox.confirm('确定要解除医事通绑定吗？', '提示', {
      confirmButtonText: '确定',
      type: 'warning',
    }).then(async () => {
      const res = await userBindDelete({
        id: userStore.getBindYishitongInfo?.id,
      })
      if (res.code == 0) {
        ElMessage.success('解除成功')
        showFn()
      }
    })
  }
}
const logout = async () => {
  await userStore.logout()
}
const showFn = async () => {
  userStore.setBinYishitongInfo()
}
const popOverRef = ref()
const jumpProductCenterFn = () => {
  router.push({
    name: '/manage',
    query: {
      tab: 'ProductCenter',
    },
  })
  popOverRef.value?.handleCloseFn()
}
</script>
<style lang="scss" scoped>
.el-dropdown {
  margin-right: 20px;
}
.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.user-photo {
  border-radius: 50%;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}
.user_name {
  padding-left: 10px;
  font-weight: 500;
  color: var(--text);
}
.pop_box {
  width: 200x;
  .icon-play {
    font-size: var(--font-size-large);
  }
}
.header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border);
  .header_right {
    margin-left: 5px;
    p {
      margin: 0;
      font-weight: 500;
    }
  }
}
.pop_item {
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-small);
  cursor: pointer;
}
.right_icon {
  margin-left: 5px;
}
</style>
